export default __webpack_public_path__ + "e09e744b1c5c3f19e8ecc302679f594f.svg";